import { Injectable } from '@angular/core';
import { HttpRequest } from '../../models';
import { HttpProviderService } from '../../services';
import { Observable } from 'rxjs';
import { ProcessShellService } from 'src/app/process-shell/services/process-shell.service';
import { CommonService } from 'src/app/common.service';
export interface FPXFileUpload {
  upload(data: any): any;
  download(data: any): any;
}


export abstract class FPXFileUploadService implements FPXFileUpload {
  abstract upload(data: any): any;
  abstract download(data: any): any;
}

@Injectable({
  providedIn: 'root',
})
export class FPXFakeFileUploadService extends FPXFileUploadService {

  constructor(private _httpProvider: HttpProviderService, 
    private _processShellService: ProcessShellService,
    private _commonService: CommonService) {
    super()
  }
  upload(data: any, documentType?: string, parentDocType?: string, nameofDoc?:string): Observable<any> { 
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      let resource = documentType?documentType: 'PASSPORT';
      httpRequest.setResource('/document');
      httpRequest.addQueryParameter('documentType', resource);
      httpRequest.addQueryParameter('prntDocType', parentDocType || resource);
      httpRequest.addQueryParameter('nameondoc', nameofDoc);
      httpRequest.addHeaderParamter('Content-Type', 'multipart/form-data');
      httpRequest.addHeaderParamter('appRef', this._commonService.doEncrypt(this._processShellService.processId));
      httpRequest.addHeaderParamter('processCode', this._processShellService.processCode);
      httpRequest.setAuthTokenRequired(true);
      let bodyContent = data;
      httpRequest.setBody(bodyContent);
      let sContext = `/olive/publisher`;
      return this._httpProvider.invokeRestApi(httpRequest); 
  }

  download(data: any): Observable<any> {
    const httpRequest = new HttpRequest();
    httpRequest.setMethod('GET');
    httpRequest.setResource(`/documentdownload/${data}`);
    httpRequest.addHeaderParamter('appref', this._commonService.doEncrypt(this._processShellService.processId));
    httpRequest.addHeaderParamter('processcode', this._processShellService.processCode);
    httpRequest.setAuthTokenRequired(true);
    return this._httpProvider.invokeDownloadApi(httpRequest);
  }
}


